<template>

  <template v-if="!isLoading">

    <section class="mb-30 lg:mb-80">

      <div class="container">

        <h1 class="font-bold text-center text-xl lg:text-2xl mb-25 leading-24 lg:leading-28">Configurateur Open</h1>

        <ol class="stepper">

          <li class="step isPrevious">
            <a @click.prevent="$emit('switchToEtape1');taggage('configurateur_open', 'etapes_tunnel', 'etape_1', { tealium_event: 'select_content' })" href="javascript:void(0)">
              <span class="outerNbr"><span class="nbr">1</span></span>
              <span class="txt">Mobile</span>
            </a>
          </li>

          <li class="step isPrevious">
            <a @click.prevent="$emit('switchToEtape2');taggage('configurateur_open', 'etapes_tunnel', 'etape_2', { tealium_event: 'select_content' })" href="javascript:void(0)">
              <span class="outerNbr"><span class="nbr">2</span></span>
              <span class="txt">Forfait mobile</span>
            </a>
          </li>

          <li class="step isPrevious">
            <a @click.prevent="$emit('switchToEtape3');taggage('configurateur_open', 'etapes_tunnel', 'etape_3', { tealium_event: 'select_content' })" href="javascript:void(0)">
              <span class="outerNbr"><span class="nbr">3</span></span>
              <span class="txt">Connexion</span>
            </a>
          </li>

          <li class="step isActive" aria-current="step">
            <a href="#">
              <span class="outerNbr"><span class="nbr">4</span></span>
              <span class="txt">Offre Internet</span>
            </a>
          </li>

          <li class="step">
            <a href="#">
              <span class="outerNbr"><span class="nbr"><span class="block w-14 lg:w-24 h-14 lg:h-24 c-grey11"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 20"><path fill="currentColor" fill-rule="evenodd" d="m24.9063 3.3549-13.6551 15.75-.0004-.0002c-.391.4503-.9917.7391-1.6657.7391-.674 0-1.2747-.2888-1.6657-.7391l-.0004.0002-6.8275-7.875.0003-.0003C.7993 10.8926.6239 10.4654.6239 10c0-.5437.2388-1.0358.6249-1.3921l.8535-.7875c.386-.3563.9195-.5766 1.5087-.5766.5302 0 1.015.1789 1.3882.4743l.0003-.0004 4.1589 4.2511L21.781.6888l.0004.0003c.3815-.3303.8944-.5329 1.4588-.5329 1.1784 0 2.1337.8815 2.1337 1.9688 0 .4653-.1754.8926-.4679 1.2296l.0003.0003Z" clip-rule="evenodd"/></svg></span></span></span>
              <span class="txt">Terminé !</span>
            </a>
          </li>

        </ol>
      </div>

    </section>

    <section class="sliderPoOffreInternet">
      <div class="container mb-50 lg:mb-120">
        <h2 v-if="data_etape0.field_etape4_titre" class="anchorTitle lg:text-xl text-center text-bold leading-22 lg:leading-24 mb-10 lg:mb-20">{{ data_etape0.field_etape4_titre }}</h2>
        <p v-if="data_etape0.field_etape4_sous_titre" class="text-center">{{ data_etape0.field_etape4_sous_titre }}</p>

        <div class="splide mb-20" aria-label="Slider choix mobile à tarif exclusif">
          <div class="splide__track py-30">
            <ul class="splide__list mt-40">
              <li v-for="(livebox, index) in sortedLivebox"  :key="index" class="splide__slide col-span-full item relative" :class="sortedLivebox.filter(l => l.prixservice).length === 3 ? 'lg:col-span-4' : 'lg:col-span-6'">

                  <span v-if="parcours.typeconnexion === 'offre_adsl'" class="jumperRight dflex dflex-col items-center gap-5 justify-center w-60 absolute top-0 right-0 gradient-blue">
                    <span class="block w-24 h-auto shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 27 16">
                          <path d="M19.62 15.1205a1.2733 1.2733 0 0 0 .3628-.8938c0-.3224-.1196-.6489-.3628-.8938a8.527 8.527 0 0 0-12.2401 0c-.4824.4939-.4824 1.2978 0 1.7916a1.219 1.219 0 0 0 1.7503 0 6.0888 6.0888 0 0 1 8.7395 0 1.219 1.219 0 0 0 1.7503 0v-.004Z"/>
                          <path d="M13.5001 7.897c2.8387 0 5.51 1.1304 7.5155 3.1873a1.2192 1.2192 0 0 0 1.7503 0 1.2733 1.2733 0 0 0 .3628-.8938c0-.3224-.1196-.6489-.3628-.8938-2.476-2.5343-5.7653-3.93-9.2658-3.93-3.5006 0-6.7939 1.3957-9.2658 3.93-.4825.4939-.4825 1.2978 0 1.7916a1.2192 1.2192 0 0 0 1.7502 0C7.994 9.0315 10.6613 7.901 13.5001 7.901v-.004Z"/>
                          <path d="M24.1653 7.048a1.2192 1.2192 0 0 0 1.7503 0c.2432-.2489.3628-.5713.3628-.8937s-.1196-.6489-.3628-.8938c-6.8457-7.0113-17.9854-7.0113-24.827-.004-.4825.4938-.4825 1.2977 0 1.7915a1.2192 1.2192 0 0 0 1.7502 0c5.8808-6.0196 15.4496-6.0196 21.3305 0h-.004Z"/>
                      </svg>
                    </span>
                    <span class="text-xs font-bold">ADSL</span>
                  </span>
                  <span v-else class="jumperRight dflex dflex-col items-center gap-5 justify-center w-60 absolute top-0 right-0 gradient-blue">
                    <span class="block w-24 h-auto shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 41">
                        <g fill="currentColor" clip-path="url(#a)">
                          <path d="M20.5 20.8884c1.9167 0 3.5-1.64 3.5-3.6252 0-1.9853-1.5417-3.6685-3.5-3.6685S17 15.2347 17 17.22c0 .7768.2083 1.4674.625 2.0284-1.125 1.8558-2.375 4.7042-3.0417 8.5453h-1.5V16.0979c1.375-.4747 2.4167-1.8126 2.4167-3.4095 0-1.9852-1.5833-3.6252-3.5-3.6252s-3.5 1.64-3.5 3.6252c0 1.5969 1 2.9348 2.4167 3.4095v11.7389h-1.5C8.75 23.9958 7.5 21.1905 6.375 19.2916c.375-.6042.625-1.2948.625-2.0284 0-1.9853-1.5833-3.6253-3.5-3.6253S0 15.2779 0 17.2632c0 1.9852 1.5833 3.6252 3.5 3.6252.375 0 .75-.0863 1.125-.2158.9167 1.5969 1.9583 3.9706 2.5833 7.1642H5.9167c-.5834 0-1.0834.5179-1.0834 1.1221v3.6253H4.25c-.5833 0-1.0833.5179-1.0833 1.1221v6.1716c0 .6042.5 1.1221 1.0833 1.1221.5833 0 1.0833-.5179 1.0833-1.1221v-5.0495H18.75v5.0495c0 .6042.5 1.1221 1.0833 1.1221.5834 0 1.0834-.5179 1.0834-1.1221v-6.2147c0-.6043-.5-1.1221-1.0834-1.1221H19.25v-3.6253c0-.6474-.5-1.1221-1.0833-1.1221H16.875c.5833-3.1937 1.625-5.5674 2.5417-7.1642.3333.1726.7083.2589 1.0833.2589Zm-8.5-9.581c.75 0 1.3333.6042 1.3333 1.381 0 .7769-.5833 1.3811-1.3333 1.3811-.75 0-1.3333-.6042-1.3333-1.3811 0-.7768.5833-1.381 1.3333-1.381ZM2.1667 17.22c0-.7768.5833-1.3811 1.3333-1.3811.75 0 1.3333.6043 1.3333 1.3811S4.25 18.6011 3.5 18.6011c-.75 0-1.3333-.6043-1.3333-1.3811Zm14.875 15.3211H7v-2.46h10.0417v2.46ZM20.5 15.8821c.75 0 1.3333.6042 1.3333 1.3811 0 .7768-.5833 1.381-1.3333 1.381-.75 0-1.3333-.6042-1.3333-1.381.0416-.7769.625-1.3811 1.3333-1.3811Z"/>
                          <path d="M6.2917 7.121c-.4166.4748-.375 1.1653.0417 1.5969.4583.4316 1.125.3884 1.5416-.0432C8.9584 7.4663 10.4168 6.819 12 6.819c1.5834 0 3.0417.6473 4.125 1.8557.2084.259.5.3453.7917.3453.25 0 .5417-.0863.75-.3021.4583-.4316.4583-1.1221.0417-1.5968-1.5-1.64-3.5417-2.5895-5.7084-2.5895-2.2083 0-4.25.9063-5.7083 2.5895Z"/>
                          <path d="M3.9583 5.7832c.2916 0 .5833-.1295.7916-.3453C6.6666 3.3663 9.2083 2.2442 12 2.2442c2.7917 0 5.3334 1.1221 7.25 3.1937.4167.4316 1.125.4747 1.5417.0431.4167-.4315.4583-1.1652.0417-1.5968C18.4999 1.3811 15.3749 0 11.9999 0c-3.375 0-6.5 1.381-8.8333 3.8842-.4167.4316-.4167 1.1653.0417 1.5968.2083.2158.5.3022.75.3022Z"/>
                        </g>
                        <defs>
                          <clipPath id="a">
                            <path fill="currentColor" d="M0 0h24v41H0z"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                  </span>

                  <div class="bg-white c-black pt-30 lg:pt-40 pb-10 lg:pb-20 px-20 lg:px-50">

                    <h3 class="text-xl lg:text-3xl leading-24 lg:leading-34 font-bold mb-35">{{ livebox.title }}</h3>

                    <div v-html="livebox.field_description?.replace(/color_white/g, 'color_black').replace(/<li>/g, `<li class='text-bold'>`)" data-equalize="poOffreInternet" data-equalize-nomobile class="richContent"></div>

                    <div class="font-bold mt-20 mb-10">
                      <span class="c-orange text-35 leading-40">{{ Number(livebox.prixservice).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span><span>&nbsp;/mois</span>
                    </div>

                    <div class="dflex justify-center text-center">
                      <a @click.prevent="loadDialog($event);taggage('carte_internet', 'voir_en_detail', livebox.title.replace(/\s+/g, '_'), { tealium_event: 'select_content' })" :data-liveboxid="livebox.nid" class="underline hover:no-underline font-bold py-10" href="#">Voir en détail</a>
                    </div>

                  </div>

                  <div class="border-t2-grey15">
                    <button @click="selectLivebox($event);taggage('carte_internet', 'choisir_cette_offre', livebox.title.replace(/\s+/g, '_'), { tealium_event: 'select_content' })" :data-id="livebox.nid" class="bg-white hover:bg-orange c-black hover:c-white w-full h-50 text-center pointer text-bold chooseLivebox" type="button">Choisir cette offre</button>
                  </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="dflex justify-center gap-15 lg:gap-30 mb-50 lg:mb-110">
        <button  @click.prevent="$emit('switchToEtape3');taggage('configurateur_open', 'etape_4', 'annuler', { tealium_event: 'select_content' })" type="button" class="resetmobile btn btn--md btn--fill-light w-full max-w-170">Précédent</button>
        <button  @click="loadNext();taggage('configurateur_open', 'etape_4', 'suivant', { tealium_event: 'select_content' });taggage('', '', '', { tealium_event: 'product_click', offre_id: [props.parcours.livebox], offre_marque: ['orange'], offre_type: [typeLivebox], offre_modele: [''], offre_qte: [1], offre_libelle: [(data_etape4.liveboxes[props.parcours.livebox].title).replace(/\s+/g, '_')], offre_prix_ttc: ['']})" type="button" class="nextmobile btn btn--md btn--fill-dark w-full max-w-170" :disabled="!isEnabled">Suivant</button>
      </div>

    </section>

    <component :is="recapComponent" :key="recapKey" :parcours="parcours" :tag="tag" :data_etape0="data_etape0" :paragraphId="paragraphId" @switchToEtape1="$emit('switchToEtape1')" @switchToEtape2="$emit('switchToEtape2')" @switchToEtape3="$emit('switchToEtape3')" @switchToEtape4="$emit('switchToEtape4')" @switchToEtape5="$emit('switchToEtape5')"/>

    <dialog class="jsModale jsModale--light" data-modale-id="1">

      <header class="font-bold py-15 px-20 pr-30">
        <p>Le détail de votre offre {{ liveboxTitle }}</p>
        <button class="jsModaleClose absolute top-0 right-0 w-40 h-40 pointer z-10" type="button" title="Fermer la modale"><span class="sr-only">Fermer la modale</span><span class="c-black dflex-center" aria-hidden="true"><img src="@/assets/images/ico-cross.svg" alt="" /></span></button>
      </header>


      <section class="p-20 relative">



        <div>
          <p class="font-bold text-xl lg:text-22 leading-24 lg:leading-26 mb-35 lg:mb-24">Composition de l'offre</p>
        </div>
        <div class="pb-40 richContent">
          <div v-html="liveboxDescription"></div>
        </div>


      </section>

      <!-- <footer></footer> -->

    </dialog>

  </template>

</template>

<script setup>
import { ref, computed } from 'vue';
import { onMounted, watch, nextTick } from 'vue';
import Etape5Recap from './Etape5Recap.vue';
import { taggage } from '@/utils/taggage.js';
import { globalStore } from '@/utils/store.js';

globalStore.tag.tealium_event = "product_click";

const data_etape4 = ref({});
const error_etape4 = ref(null);
const liveboxTitle = ref({});
const liveboxDescription = ref({});
const isEnabled = ref(false);
const isLoading = ref(true);

const props = defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  tag: Object
});

const recapKey = ref(0);

//defineEmits(['switchToEtape1']);
const emit = defineEmits(['switchToEtape1','switchToEtape2','switchToEtape3','switchToEtape4','switchToEtape5']);

const recapComponent = ref(null);
recapComponent.value = Etape5Recap;


const sortedLivebox = computed(() => {
  const boxes = data_etape4.value?.liveboxes;
  if (!boxes) return [];
  const list = Array.isArray(boxes) ? boxes : Object.values(boxes);

  const filtered = list.filter(item => item?.prixservice !== undefined && item?.prixservice !== null && item?.prixservice !== '');

  return filtered.sort((a, b) => Number(a.field_poids) - Number(b.field_poids));
});

const typeLivebox = computed(() => {

  //console.log('conn:'+props.parcours.livebox+'//'+data_etape4.value.liveboxes[props.parcours.livebox].title);
  const arrayOffre = {'Essentiel' : 'offre_essentiel', 'Infini' : 'offre_infini', 'Ultra' : 'offre_ultra'};
  return arrayOffre[data_etape4.value.liveboxes[props.parcours.livebox].title];

});


const loadNext = () => {
  emit('switchToEtape5');
};

function jsModale() {
  const modale = document.querySelector('.jsModale');
  modale.showModal();
  modale.querySelector('.jsModaleClose').addEventListener('click', closeModale);
  modale.addEventListener('click', e => closeModal(e));
}

function closeModale(e) {
  const modale = e.currentTarget.parentElement.parentElement;
  modale.close();
  e.target.removeEventListener('click', closeModale);
}

function closeModal(e) {
    //console.log('close Modal');
    const modale = document.querySelector('.jsModale');

    const modaleHeader = modale.querySelector('header');
    const modaleContent = modale.querySelector('section');
    const modaleFooter = modale.querySelector('footer');

    modale.querySelector('.jsModaleClose').addEventListener('click', function() {
      //console.log('Croix Modale');
      modale.close();
      modale.removeEventListener('click', closeModal);
    });

    if (modaleHeader.contains(e.target) || modaleContent.contains(e.target)) {
      //console.log('close Modal 1');
      return;
    } else {
      //console.log('close Modal 2');
      modale.close();
      modale.removeEventListener('click', closeModal);
    }
}

function loadDialog(event) {
  //console.log('loadDialog');
  var livebox = event.target;
  //console.log(livebox.dataset.liveboxid);
  liveboxDescription.value = data_etape4.value.liveboxes[livebox.dataset.liveboxid].field_description_longue;
  liveboxTitle.value = data_etape4.value.liveboxes[livebox.dataset.liveboxid].title;
  jsModale();
};

function selectLivebox(event) {
  //emit('enableSelect');
  enableSelect();

  var livebox = event.target;
  if (livebox.classList.contains('bg-white') && livebox.classList.contains('c-black')) {
    livebox.classList.remove("bg-white","c-black");
    livebox.classList.add("bg-orange", "c-white");
  }

  const liParent = livebox.closest('li');
  if (liParent) {
    liParent.classList.add("isSelected");
  }
  livebox.textContent = "Offre sélectionnée";
  props.parcours.livebox = livebox.dataset.id;
  recapKey.value++;
  //props.parcours.mobile = mobile.dataset.id;
  //console.log('Parcours Mobile:'+props.parcours.value);

  const buttons = document.querySelectorAll('.chooseLivebox');
  buttons.forEach(btn => {
    if (btn !== livebox) {
      const parent = btn.parentElement;
      const prevSibling = parent.previousElementSibling;
      btn.classList.remove('bg-orange','c-white','bg-white','c-black','bg-black'); // supprime 'toto' sur tous les autres
      if (prevSibling.classList.contains('bg-white') && prevSibling.classList.contains('c-black')) {
        btn.classList.add("bg-white", "c-black");
      }
      if (prevSibling.classList.contains('bg-grey14') && prevSibling.classList.contains('c-white')) {
        btn.classList.add("bg-grey14", "c-white");
      }
      if (prevSibling.classList.contains('bg-black') && prevSibling.classList.contains('c-white')) {
        btn.classList.add("bg-black", "c-white");
      }
      btn.textContent = "Choisir cette offre";
      const liParentOther = btn.closest('li');
      if (liParentOther) {
        liParentOther.classList.remove("isSelected");
      }
    }
  });
}

function enableSelect() {
  isEnabled.value = true
}


onMounted(async () => {
  try {
    //console.log('Etape4Inner mounted');
    props.parcours.etape = 4;
    const params = new URLSearchParams({
      mobile: props.parcours.mobile,
      multilignes: props.parcours.multiligne,
      forfait: props.parcours.forfait,
      typeconnexion: props.parcours.connexion,
      typeforfait: props.parcours.livebox,
      additionnels: props.parcours.multilignes,
    });
    const res = await fetch(`/packopenv3/etape4?${params}`);
    if (!res.ok) throw new Error(`Erreur HTTP ${res.status}`);
    data_etape4.value = await res.json();

    await nextTick();

    if (props.parcours.livebox != 0) {
      //console.log('Livebox Existe');
      const bouton = document.querySelector('.chooseLivebox[data-id="' + props.parcours.livebox + '"]');
      if (bouton) {
        bouton.click();
      }
    }

  } catch (e) {
    error_etape4.value = e.message;
  } finally {
    isLoading.value = false;

    await nextTick();

    slidersPoOffreInternet();
    const anchorTitle = document.querySelector('.anchorTitle');
    if (anchorTitle) {
      anchorTitle.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  }
});

watch(
  sortedLivebox,  // on passe directement le ref
  async (newVal) => {
    if (!newVal || !newVal.length) return;

    await nextTick();  // attend que le DOM soit rendu

    await nextTick();

    //console.log('watch started');

    const equalizeElems = document.querySelectorAll('[data-equalize]');
    if (equalizeElems.length) {
      //console.log('watch déclenché');
      equalizer(equalizeElems);
    }
    if (props.parcours.livebox != 0) {
      //console.log('Livebox Existe');
      const bouton = document.querySelector('.chooseLivebox[data-id="' + props.parcours.livebox + '"]');
      if (bouton) {
        bouton.click();
      }
    }
  },
  { deep: true, immediate: true } // immediate : s'exécute aussi au montage
);

</script>
